import { motion } from "framer-motion";
import { Phone, MessageCircle, ArrowDown, Shield, Clock, Star } from "lucide-react";

const PHONE = "0643693688";
const WHATSAPP_LINK = "https://wa.me/33643693688?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20une%20enseigne.";

export function HeroSection({ onScrollToForm }) {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1766573024161-864d65c6442f?w=1920&q=80"
          alt="Enseigne lumineuse commerce nuit"
          className="w-full h-full object-cover"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/40" />
      </div>

      {/* Grain */}
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage:'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")'}} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 w-full">
        <div className="max-w-3xl">
          {/* Overline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-[#00FF66] font-bold text-sm uppercase tracking-[0.3em] mb-6 font-['Outfit',sans-serif]"
            data-testid="hero-overline"
          >
            PUB PRO
          </motion.p>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-['Clash_Display',sans-serif] text-4xl sm:text-5xl lg:text-7xl xl:text-[5.5rem] font-bold text-white leading-[0.95] tracking-tighter"
            data-testid="hero-headline"
          >
            EXPERTS EN
            <br />
            ENSEIGNES
            <br />
            <span className="text-[#00FF66]">LUMINEUSES</span>
            <br />
            EN ÎLE-DE-FRANCE
          </motion.h1>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35 }}
            className="mt-10"
          >
            <button
              onClick={onScrollToForm}
              className="inline-flex items-center gap-2 bg-[#00FF66] text-black px-8 sm:px-10 py-4 sm:py-5 font-bold text-base sm:text-lg uppercase tracking-wider hover:shadow-[0_0_40px_rgba(0,255,102,0.4)] transition-all duration-300 font-['Outfit',sans-serif]"
              data-testid="hero-cta"
            >
              Demander un devis gratuit &gt;
            </button>
          </motion.div>

          {/* Trust badges */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="flex flex-wrap items-center gap-6 mt-10 text-sm text-zinc-500 font-['Outfit',sans-serif]"
          >
            <span className="flex items-center gap-1.5"><Star className="w-4 h-4 text-[#00FF66]" /> 500+ réalisations</span>
            <span className="flex items-center gap-1.5"><Shield className="w-4 h-4 text-[#00FF66]" /> Garantie décennale</span>
            <span className="flex items-center gap-1.5"><Clock className="w-4 h-4 text-[#00FF66]" /> Réponse sous 24h</span>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.button
        onClick={onScrollToForm}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 8, 0] }}
        transition={{ delay: 1.2, y: { duration: 2, repeat: Infinity } }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-zinc-600 hover:text-[#00FF66] transition-colors z-10"
        aria-label="Défiler vers le bas"
      >
        <ArrowDown className="w-6 h-6" />
      </motion.button>
    </section>
  );
}
